import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { Modal } from "../../../components/Modal.jsx";
import { T } from "../../../app/tokens.js";
import { btn } from "../weekly/weeklyUi.js";

// Unlike the dismissible remove popover, leaving with real work is a modal
// decision. Capture Escape before the sheet's document listener sees it.
export function MediaLeavePrompt({ intent, busy, uploading, dirty, error, onStay, onSave, onDiscard, onCancelUpload, onContinue }) {
  const host = useRef(null);
  const stay = () => {
    const trigger = intent?.trigger;
    onStay();
    requestAnimationFrame(() => {
      if (trigger?.isConnected && !trigger.closest("[hidden]")) trigger.focus({ preventScroll: true });
    });
  };
  const close = useRef(stay); close.current = stay;
  useEffect(() => {
    if (!intent) return undefined;
    const key = event => {
      if (event.key === "Escape") {
        event.preventDefault(); event.stopImmediatePropagation(); close.current();
      }
      if (event.key === "Tab") {
        const buttons = [...(host.current?.querySelectorAll("button:not([disabled])") || [])];
        const first = buttons[0], last = buttons[buttons.length - 1];
        if (!buttons.includes(document.activeElement) || (event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last)) {
          event.preventDefault(); (event.shiftKey ? last : first)?.focus();
        }
      }
    };
    window.addEventListener("keydown", key, true);
    return () => window.removeEventListener("keydown", key, true);
  }, [intent]);
  if (!intent) return null;
  return createPortal(<Modal isOpen title={uploading ? "Upload in progress: wait or cancel" : busy ? "Media change is saving" : dirty ? "Unsaved caption: save or discard" : "Media change finished"}
    ariaLabelledBy="media-leave-title" onClose={stay}>
    <div ref={host} style={{ padding: 16 }}>
      <p>{uploading ? "Cancelling stops queued files and the active request. Completed files stay. A file already accepted by the server may still appear when the gallery refreshes."
        : busy ? "Wait for this immediate-save action to finish, then continue." : dirty ? "Save this caption before leaving, discard the draft, or stay here." : "You can now continue to your destination."}</p>
      {error && <p role="alert" style={{ color: T.red, whiteSpace: "pre-wrap" }}>{error}</p>}
      <button autoFocus type="button" style={btn} onClick={stay}>Stay</button>{" "}
      {uploading ? <button type="button" style={btn} onClick={onCancelUpload}>Cancel uploads and continue</button>
        : !busy && dirty ? <><button type="button" style={btn} onClick={onSave}>Save and continue</button>{" "}<button type="button" style={btn} onClick={onDiscard}>Discard and continue</button></>
          : !busy && <button type="button" style={btn} onClick={onContinue}>Continue</button>}
    </div>
  </Modal>, document.body);
}
